import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './speechdetailses.routes';
import addHtml from './modal/add.html';
import _ from 'lodash';


export class SpeechDetailsEsController {
    $http;
    socket;
    awesomeThings = [];
    speechDetails = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
    }

    $onInit() {

        if (this.$cookies.get('token')) {

            this.$http.get('/api/speech_type_es/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.speechTypeName = response.data.data;
                    }
                });

            this.getTypeName = function (id) {
                let _name = _.find(this.speechTypeName, { speech_type_id: id });
                return _name.speech_type_name;
            }



            this.$http.get('/api/speech_details_es/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.speechDetails = response.data.data;
                        this.socket.syncUpdates('speechDetails', this.speechDetails);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/speech_details_es/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.speechDetails = response.data.data;
                        this.socket.syncUpdates('speechDetails', this.speechDetails);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    addSpeechDetails() {
        const speechDetails = this.speechDetails;

        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                $scope.vm = {};

                $scope.isload = false;
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;


                $http.get('/api/speech_type_es/', {
                    header: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': $cookies.get('token')
                    }
                })
                    .then(response => {
                        if (response.data.data) {
                            response.data.data.splice(0, 1);
                            $scope.speechTypes = response.data.data;
                        }
                    });


                $scope.changeType = function (index) {

                    $http.get('/api/speech_profile_es/' + index + '/9527/')
                        .then(response => {
                            if (response.data.data) {
                                $scope.speechProfile = response.data.data;
                            }
                        });
                }

                $scope.selectProfile = function (value) {
                    let obj = _.find($scope.speechProfile, { 'speech_profile_id': value });
                    $scope.vm['cover_img'] = obj.cover_img;
                    $scope.vm['collection_name'] = obj.speech_name;
                    $scope.vm['profile'] = obj.profile;
                    console.log($scope.vm);
                }


                let uploader = $scope.uploader = new FileUploader({
                    url: '/api/speech_profiles/9527/',
                    method: 'POST',
                    autoUpload: true,
                });



                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/speech_profiles/9529/',
                    method: 'POST',
                    autoUpload: true,
                });


                uploader.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        console.log(item);
                        if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
                            $scope.isload = true;
                            $scope.isloadSpeechUrlError = false;
                            let s = item.name.split('.');
                            $scope.vm.speech_name = s[0];
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadSpeechUrlError = true;
                            return false;
                        }

                    }
                });



                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        console.log(item);
                        console.log(options);
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoversmallError = true;
                            return false;
                        }

                    }
                });

                uploader.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isload = false;
                        $scope.vm.speech_url = response.data.speech_url;
                        $scope.vm.speech_size = response.data.speech_size;
                        // $scope.vm.speech_during = response.data.speech_during;
                    }
                };

                $scope.clearItems = function () {
                    uploader.clearQueue();
                }


                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.cover_small_img = response.data.cover_small_img;
                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }

                $scope.save = function (myForm) {
                    console.log($scope.vm.profile);
                    if (myForm.$valid === false && $scope.isload === false) {
                        return false;
                    } else {
                        let ret = {
                            speech_profile_id: $scope.vm.speech_profile_id,
                            collection_name: $scope.vm.collection_name,
                            speech_type_id: $scope.vm.speech_type_id,
                            speech_name: $scope.vm.speech_name,
                            speech_url: $scope.vm.speech_url,
                            cover_img: $scope.vm.cover_img,
                            cover_small_img: $scope.vm.cover_small_img,
                            profile: $scope.vm.profile,
                            desc: $scope.vm.desc,
                            speech_size: $scope.vm.speech_size,
                            speech_during: $scope.vm.speech_during,
                        };

                        $http.post('/api/speech_details_es/', ret).then((response) => {
                            console.log(response.data.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (data) {
                if (data) {
                    speechDetails.push(data);
                }
            }, function () {
            });
    }


    editSpeechDetails(type, index) {
        const speechDetails = this.speechDetails;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                $scope.vm = angular.copy(type);
                console.log($scope.vm);
                $scope.isload = false;
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;


                $http.get('/api/speech_type_es/', {
                    header: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': $cookies.get('token')
                    }
                })
                    .then(response => {
                        if (response.data.data) {
                            response.data.data.splice(0, 1);
                            $scope.speechTypes = response.data.data;
                        }
                    });


                if ($scope.vm.speech_type_id) {
                    $http.get('/api/speech_profile_es/' + $scope.vm.speech_type_id + '/9527/')
                        .then(response => {
                            if (response.data.data) {
                                $scope.speechProfile = response.data.data;
                                let obj = _.find($scope.speechProfile, { 'speech_profile_id': $scope.vm.speech_profile_id });
                                if (obj) {
                                    $scope.vm['cover_img'] = obj.cover_img;
                                    $scope.vm['collection_name'] = obj.speech_name;
                                    $scope.vm['profile'] = obj.profile;

                                }
                            }
                        });
                }


                $scope.changeType = function (index) {

                    $http.get('/api/speech_profile_es/' + index + '/9527/')
                        .then(response => {
                            if (response.data.data) {
                                $scope.speechProfile = response.data.data;
                            }
                        });
                }

                $scope.selectProfile = function (value) {
                    let obj = _.find($scope.speechProfile, { 'speech_profile_id': value });
                    if (obj) {
                        $scope.vm['cover_img'] = obj.cover_img;
                        $scope.vm['collection_name'] = obj.speech_name;
                        $scope.vm['profile'] = obj.profile;
                        console.log($scope.vm);
                    }

                }


                let uploader = $scope.uploader = new FileUploader({
                    url: '/api/speech_profiles/9527/',
                    method: 'POST',
                    autoUpload: true,
                });



                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/speech_profiles/9529/',
                    method: 'POST',
                    autoUpload: true,
                });


                uploader.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        console.log(item);
                        if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
                            $scope.isload = true;
                            $scope.isloadSpeechUrlError = false;
                            let s = item.name.split('.');
                            $scope.vm.speech_name = s[0];
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadSpeechUrlError = true;
                            return false;
                        }

                    }
                });



                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        console.log(item);
                        console.log(options);
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoversmallError = true;
                            return false;
                        }

                    }
                });

                uploader.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isload = false;
                        $scope.vm.speech_url = response.data.speech_url;
                        $scope.vm.speech_size = response.data.speech_size;
                        // $scope.vm.speech_during = response.data.speech_during;
                    }
                };

                $scope.clearItems = function () {
                    uploader.clearQueue();
                }


                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.cover_small_img = response.data.cover_small_img;
                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }

                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        console.log($scope.vm);
                        $http.put('/api/speech_details_es/' + type.details_id + '/', $scope.vm).then((response) => {
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    speechDetails[index] = ret;
                }
            }, function () {
            });
    }



    deleteSpeechDetails(type, index) {
        this.$http.delete('/api/speech_details_es/' + type.details_id + '/').then(response => {
            if (response.status === 200) {
                this.speechDetails.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.speechdetailses', [uiRouter])
    .config(routing)
    .component('speechdetailses', {
        template: require('./speechdetailses.html'),
        controller: SpeechDetailsEsController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/speechdetailses/speechdetailses.component.js